
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.743 1.943c.94 0 1.789.353 2.404.924a3.04 3.04 0 01.996 2.233c0 .873-.38 1.661-.996 2.233a3.527 3.527 0 01-2.404.924c-.94 0-1.79-.353-2.405-.924A3.04 3.04 0 015.343 5.1c0-.873.38-1.661.995-2.233a3.527 3.527 0 012.405-.924z","fill":"#0E6199"}}),_c('path',{attrs:{"d":"M8.587 1.943c.184 0 .364.014.54.044.067.282.101.576.101.878 0 1.925-1.445 3.536-3.378 3.935a3.095 3.095 0 01.442-3.93 3.276 3.276 0 012.292-.925l.003-.002z","fill":"#1269A3"}}),_c('path',{attrs:{"d":"M1.945 12.577c-.008-.518.032-1.513.926-2.381.857-.833 2.496-1.53 5.64-1.488 3.136.042 4.773.713 5.627 1.52.894.845.936 1.806.915 2.402 0 1.414-1.648 2.302-3.791 2.688a15.22 15.22 0 01-2.632.225 15.816 15.816 0 01-2.647-.209c-2.247-.38-4.017-1.297-4.038-2.757z","fill":"#0E6199"}}),_c('path',{attrs:{"d":"M1.945 12.484c0-.538.082-1.47.926-2.288.854-.829 2.483-1.523 5.595-1.488.342.404.536.863.536 1.353 0 1.59-2.054 2.878-4.587 2.878-.91 0-1.759-.167-2.473-.453l.003-.002z","fill":"#1269A3"}})])
          )
        }
      }
    